<template>
  <div class="form-group required" :class="hideTurnoverForMobile">
        <ValidationProvider tag="div"
                        class="form-field field-textfield"
                        :class="{ required: isRequired } + ' ' + activeField"
                        :rules="rules"
                        :immediate="!!value"
                        v-slot="{ classes, errors }">
                <input :type="inputType"
               :id="'textfield-' + _uid"
               class="form-control"
               :class="classes"
               :value="value"
               :placeholder="placeholder"
               :autocomplete="autocomplete"
               :required="required"
               :pattern="pattern"
               :maxlength="maxlength"
               :inputmode="inputmode"
               :disabled="disabled"
               :min="min"
               :max="max"
               @keyup="inputFocusHandler($event)"
               @keydown.enter.stop.prevent
               @blur="$emit('blur')"
               @input="$emit('input', $event.target.value)">
            <label v-if="label" :for="'textfield-' + _uid" class="floating-label" :class="hideAsterisk">{{ label }}</label>

        <div v-if="errors[0]" class="errors"><SvgIcon type="attention_bar"/>{{ errors[0] }}</div>
        <slot/>
    </ValidationProvider>
  </div>
</template>

<script>
import BaseField from './BaseField'
import SvgIcon from '@/components/SvgIcon'

export default {
    name: 'TextField',
    extends: BaseField,
    components: {
        SvgIcon
    },
    data: () => ({
        activeField: false
    }),
    props: {
        inputType: {
            type: String,
            default: 'text'
        },
        hideAsterisk: String,
        hideTurnoverForMobile: String,
        label: String,
        disabled: Boolean,
        placeholder: String,
        autocomplete: String,
        pattern: String,
        maxlength: String,
        inputmode: String,
        min: String,
        max: String,
        customLabelClass: String
    },
    methods: {
        inputFocusHandler(event) {
            this.activeField = (event.target.value !== '') ? 'active' : ''
        }
    },
    mounted() {
        this.activeField = (this.value !== '') ? 'active' : ''
    }
}
</script>
